module.exports = __webpack_public_path__ + "img/branch-particle-01.1b8b5630.png";